import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Sobre: React.FC = () => {


  return (
    <>

 
      <Container id="equipe" >
        <h2 style={{color: '#333'}}>
          Equipe Organizadora
        </h2>

        <p style={{color: '#333'}}>A equipe organizadora do evento “Ensino de Ética nos cursos de Engenharia Civil e Arquitetura e Urbanismo” é formada por professores e pesquisadores da ANTAC:</p>

        <p style={{color: '#333'}}>
       
<strong>Prof. Dr. Sérgio Scheer</strong><br/><p style={{fontSize:'14px'}}>Presidente da ANTAC - UFPR</p>
<br/><strong>Profª.  Drª. Débora de Gois Santos</strong><br/><p style={{fontSize:'14px'}}>Diretora de relações interinstitucionais da ANTAC – UFS, Coordenadora do evento</p>
<br/><strong>Prof. Dr. José de Paula Barros Neto</strong><br/><p style={{fontSize:'14px'}}>UFC</p>
<br/><strong>Drª. Maria Angélica Covelo Silva</strong><br/><p style={{fontSize:'14px'}}>NGI</p>
<br/><strong>Profª. Drª. Flávia Rodrigues de Souza</strong><br/><p style={{fontSize:'14px'}}>Orientadora do Mestrado Profissional em Inovação na Construção Civil da Escola Politécnica da USP- CONSTRUINOVA</p>
<br/><strong>Profª. Drª. Luciana Inês Gomes Miron</strong><br/><p style={{fontSize:'14px'}}>UFRGS</p>
<br/><strong>Prof. Dr. Renato Martins das Neves</strong><br/><p style={{fontSize:'14px'}}>UFPA</p>
<br/><strong>Profª. Ma. Tathyana Moratti</strong><br/><p style={{fontSize:'14px'}}>Universidade São Judas Tadeu – USJT</p>
<br/><strong>Prof. Msc. Domingos Sávio Sousa</strong><br/><p style={{fontSize:'14px'}}>UNIFOR</p>
        </p>

      </Container>
    </>
  );
};
export default Sobre;
